<template>
  <div class="search-categories">
    <ServicesCategoriesList
      :list="categories"
      is-main
      @setActive="setActive"
      :actives="actives"
    />
    <button
      @click="actives.pop()"
      v-show="actives.length > 2"
      class="search-categories__back-btn button-clean"
    >
      <icon name="arrow-left" width="20" height="20" />
    </button>
    <ServicesCategoriesList
      v-for="(activeList, i) in actives"
      :key="i"
      :list="activeList"
      :actives="actives"
      @setActive="setActive($event, i + 1)"
      v-show="i >= actives.length - 2"
    />
  </div>
</template>

<script>
import ServicesCategoriesList from "@/components/Custom/ServicesCategoriesList.vue";

export default {
  name: "ServicesCategories",
  components: { ServicesCategoriesList },
  props: {
    categories: Array
  },
  data() {
    return {
      // массив со всеми активными массивами категорий
      actives: []
    };
  },
  methods: {
    setActive(item, index = 0) {
      if (item.children && item.children.length) {
        this.actives.splice(index, this.actives.length, item.children || []);
      } else {
        this.actives.splice(index);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-categories {
  display: flex;
  height: 100%;

  &__back-btn {
    padding: 15px;
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    border-right: 1px solid var(--gray-darker, #d5dae5);

    &:hover {
      background: var(--gray, #f9f9f9);
    }
  }
}
</style>
